import axiosInstance from './api';

export const getInvite = (code) => {
  return axiosInstance.get('/invites/' + code)
}